export default __webpack_public_path__ + "static/media/LS.636e15ae.svg";